import { ProgressBarTooltip } from "./ProgressBarTooltip";
import { Stack, Tooltip, Typography } from "@mui/material";
import { formatDateRange } from "../../../utils/formatDateRange";
import { isTextEllipsed } from "../../../utils/general_utils";
import { RateIndicatorIcon } from "../RateIndicatorIcon";
import { AccountListItem } from "../../../types";
import { getProgressBarColor } from "../../../utils/getProgressBarColor";
import { RoundedCircularProgress } from "../RoundedCircularProgress";

export const LinerProgress = ({ data }: { data: AccountListItem }) => {
  const { indicator, change, changed_at, score, your_data, external_data } =
    data.discovery;

  const totalScore = score || 0;
  const userData = your_data || 0;
  const infuseData = external_data || 0;

  const list = [
    { text: "Your data", value: `${userData}%` },
    { text: "External Data", value: `${infuseData}%` },
    { text: "Last update:", value: formatDateRange(changed_at ?? "", true) },
    {
      text: "Change:",
      value: (change && change > 0 ? `+${change}` : change) + "%",
    },
  ];

  return (
    <Tooltip
      title={
        <Stack gap="6px" paddingY="4px">
          {list.map(({ text, value }) => (
            <ProgressBarTooltip key={text} value={value} text={text} />
          ))}
        </Stack>
      }
      placement="top"
      arrow
      sx={{
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: 400,
        "&:hover": {
          visibility: "visible",
          opacity: 1,
        },
      }}
    >
      <Stack
        alignItems="center"
        onMouseEnter={(event: React.MouseEvent<HTMLDivElement>) => {
          const target = event.currentTarget;
          isTextEllipsed(target);
        }}
      >
        <Stack alignItems="center">
          <Stack
            sx={{ position: "relative", width: "42px", height: "42px" }}
            justifyContent="center"
          >
            <Stack
              sx={{
                position: "absolute",
                left: -26,
                top: 10,
                zIndex: 2,
              }}
            >
              <RateIndicatorIcon
                indicatorRate={indicator}
                showTooltip={false}
              />
            </Stack>
            <RoundedCircularProgress
              size={42}
              thickness={4}
              variant="determinate"
              sx={{
                color: "#D4D4D4",
                position: "absolute",
                left: 0,
                top: 0,
                zIndex: 1,
                opacity: 1,
              }}
              value={100}
            />
            <RoundedCircularProgress
              size={42}
              thickness={4}
              variant="determinate"
              sx={{
                color: getProgressBarColor(totalScore),
                position: "absolute",
                left: 0,
                top: 0,
                zIndex: 3,
                opacity: 1,
              }}
              value={totalScore}
            />
            <Typography
              variant="body1"
              align="center"
              sx={{
                flexShrink: 1,
                fontSize: 11,
                fontWeight: 600,
                color: "#232323",
              }}
            >
              {totalScore}%
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Tooltip>
  );
};
